"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.missedVisitPayloadToFormDataHandler = missedVisitPayloadToFormDataHandler;
function missedVisitPayloadToFormDataHandler(data) {
    return {
        missedVisitDate: data.form.missedVisitDate,
        reason: data.form.reason,
        futureAppointment: {
            visitDate: data.form.nextVisitDate,
            visitStartTime: data.form.nextVisitStartTime,
            visitEndTime: data.form.nextVisitEndTime,
        },
        notes: data.form.notes || "",
    };
}
